import { useTranslation } from "react-i18next";
import defaultContent from "../../../content/common";
import { IconArrowBoxRight } from "../../icons/IconArrowBoxRight/IconArrowBoxRight";
import "./LeafLearnMoreLink.scss";

type Props = {
  href: string;
  onClickFn?: Function;
  theme?: "black" | "blue";
  removeBorder?: boolean;
  underline?: boolean;
  hoverState?: boolean;
};

export const LeafLearnMoreLink = ({
  href,
  onClickFn,
  theme = "black",
  removeBorder = false,
  underline = false,
  hoverState = true,
}: Props) => {
  const { t } = useTranslation(["common"]);

  return (
    <div>
      <a
        className={`leaf-learn-more-link leaf-learn-more-link__theme-${theme}
        ${removeBorder ? "" : ` leaf-learn-more-link--border`}
        ${underline ? ` leaf-learn-more-link--underline` : ""}
        ${hoverState ? ` leaf-learn-more-link--hover` : ""}`}
        onClick={() => (onClickFn ? onClickFn() : null)}
        href={href}
        target="_blank"
        rel="noreferrer"
      >
        <span className="leaf-learn-more-link__text">
          <>{t("learnMore", defaultContent["learnMore"])}</>
        </span>
        <span className="leaf-learn-more-link__icon" aria-hidden="true">
          <IconArrowBoxRight color={theme} />
        </span>
      </a>
    </div>
  );
};
